import Backbone from 'backbone'
import template from './dialog-test.hbs'
import appDisplay from 'scoreboard/components/app-display'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import multipleSizeDialog from './multiple-size-dialog.hbs'
import defaultDialog from './default-dialog.hbs'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import _ from 'lodash'
import $ from 'jquery'
import OrgTemplateWizard from 'scoreboard/organizations/org-template-wizard'
import Organization from 'scoreboard/organizations/organization'
import ErrorView from 'scoreboard/components/error-view'
import testStackTrace from './test-stack-trace.hbs'

var DefaultDialog = Backbone.View.extend({
	className: 'default-dialog',

	events: {
		'click .done': 'done'
	},

	initialize: function({ content, title } = {}) {
		this.title = title || 'Default Dialog'
		this.content = content || 'This is a regular dialog. There\'s nothing much to show but you can "Cancel" it or mark it "Done", or you can just hit the escape key to close it as well.'
	},

	render: function() {
		this.$el.empty().append(defaultDialog({
			title: this.title,
			content: this.content
		}))
		return this
	},

	done: function() {
		this.trigger('done')
	}
})

var MultipleSizeDialog = Backbone.View.extend({
	className: 'dialog-opening-dialog',

	events: {
		'click .button-dialog': 'openDialog'
	},

	render: function() {
		this.$el.append(multipleSizeDialog({
			count: $('.dialog').length,
			height: Math.random()*700 + 'px',
			width: Math.random()*700 + 'px'
		}))

		this.marked = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		return this
	},

	openDialog: function() {
		appDisplay.dialog(new MultipleSizeDialog())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.marked], 'remove')
	}
})

var DialogTest = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-dialogs',

	events: {
		'click .new-default-dialog': 'openDefaultDialog',
		'click .new-multiple-size-dialog': 'openMultipleSizeDialog',
		'click .new-promise-dialog': 'openPromiseDialog',
		'click .new-confirm-dialog': 'openConfirmDialog',
		'click .new-delete-confirmation-dialog': 'openDeleteConfirmationDialog',
		'click .template-naming-form': 'templateNamingForm',
		'click .template-destination-form': 'templateDestinationForm',
		'click .server-message': 'displayServerMessage',
		'click .generic-error': 'displayGenericError',
		'click .stack-trace': 'displayStackTrace'
	},

	initialize: function() {
		this.mockOrganization = new Organization({
			id : 1,
			label : 'My Organization',
			projectId : 1,
			replicated : false,
			replicatedCascaded : false,
			index : 0,
			domainType : 'organization'
		})
	},

	render: function () {
		this.$el.empty().append(template())
		return this
	},

	openDefaultDialog: function() {
		appDisplay.dialog(new DefaultDialog())
	},

	openMultipleSizeDialog: function() {
		appDisplay.dialog(new MultipleSizeDialog())
	},

	openPromiseDialog: function() {
		appDisplay.dialog(new Promise((resolve) => {
			// Simulate the promise taking 3 seconds to get back by setting a timeout here.
			// We should see loading dots in the dialog during that time.
			setTimeout(() => {
				resolve()
			}, 3000)
		}), () => {
			return new DefaultDialog({
				title: 'Promise Dialog',
				content: 'This is a dialog created using a promise instead of a view. There should have been loading dots displayed for 3 seconds prior to this dialog becoming visible.'
			})
		})
	},

	openConfirmDialog: function() {
		appDisplay.dialog(new ConfirmPrompt({
			titleKey: 'common.confirm',
			messageKey: 'common.confirm',
			onConfirm: function() {
				console.log('Confirm dialog confirmed!')
				return
			}
		}))
	},

	openDeleteConfirmationDialog: function() {
		var view = new DeleteConfirmation({
			description: 'TEST DESCRIPTION OBJECT'
		})
		view.on('confirm', () => {
			view.trigger('done')
		})
		appDisplay.dialog(view)
	},

	templateDestinationForm: function(orgId) {
		var wizard = new OrgTemplateWizard({ step: 1 })
		// TODO: This needs to have a tree defined for it to work
		wizard.start({
			model: this.mockOrganization,
			orgId: this.mockOrganization.id,
			section: 'organizations'
		})
	},

	templateNamingForm: function(orgId) {
		var wizard = new OrgTemplateWizard({ step: 2 })
		wizard.start({
			model: this.mockOrganization,
			orgId: this.mockOrganization.id,
			section: 'organizations'
		})
	},

	displayServerMessage: function() {
		// Wrapped in process.nextTick to bypass the dialogstack clearing in app-router.js:goTo
		process.nextTick(function() {
			appDisplay.dialog(new ErrorView({
				message: 'At least one currency must be selected',
				messageCode: 'admin.appConfiguration.dataFormat.noCurrencySelected',
				stackTrace: testStackTrace()
			}))
		})
	},

	displayGenericError: function() {
		// Wrapped in process.nextTick to bypass the dialogstack clearing in app-router.js:goTo
		process.nextTick(function() {
			appDisplay.dialog(new ErrorView({
				message: 'Spider Impact Error',
				messageCode: 'common.error.jsp.title',
				stackTrace: testStackTrace()
			}))
		})
	},

	displayStackTrace: function() {
		// Wrapped in process.nextTick to bypass the dialogstack clearing in app-router.js:goTo
		process.nextTick(function() {
			appDisplay.dialog(new ErrorView({
				message: 'This is a test stack trace.',
				stackTrace: testStackTrace()
			}))
		})
	}
})

export default DialogTest
